<div class="mfaListHeader">
  <h2 mat-dialog-title>{{ 'common.backupCodes' | t }}</h2>
  <sn-icon-button
    *ngIf="!isLoading && backupCodes"
    [isLoading]="isGenerating"
          [matTooltip]="'account.dialogs.mfa.backupCodes.generateNewCodes' | t"
    (click)="regenerateCodes()"
  >
    <sn-icon fontIcon="fa-arrows-rotate" fontSet="fal"></sn-icon>
  </sn-icon-button>
</div>
<mat-dialog-content>
  <sn-alert dense class="alert-rounded" type="danger" *ngIf="form.errors">
    <div *ngFor="let error of form.errors | keyvalue">
      <b>{{ toStartCase(error.key) }}</b
      >:
      <ng-container *ngIf="isArray(error.value); else singlePasswordError">
        <ul class="error-list">
          <li *ngFor="let item of error.value">{{ item }}</li>
        </ul>
      </ng-container>
      <ng-template #singlePasswordError>
        <ul class="error-list">
          <li>{{ error.value }}</li>
        </ul>
      </ng-template>
    </div>
  </sn-alert>
  <ng-template [ngIf]="isConfirmed && backupCodes" [ngIfThen]="backupCodesTmpl"></ng-template>
  <ng-template [ngIf]="!isConfirmed && !backupCodes" [ngIfThen]="formTmpl"></ng-template>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button color="warn" mat-dialog-close>{{ 'common.cancel' | t }}</button>
  <button
    *ngIf="!isConfirmed && !backupCodes"
    mat-button
    [mtBasicSpinner]="isLoading"
    [hideText]="true"
    [disabled]="form.invalid"
    color="success"
    (click)="checkBackupCodes()"
  >
    {{ 'common.confirm' | t }}
  </button>
</mat-dialog-actions>

<ng-template #backupCodesTmpl>
  <div class="backupCodes">
    <section>
      <p>
        {{ 'account.dialogs.mfa.backupCodes.description' | t }}<br />
        {{ 'account.dialogs.mfa.backupCodes.securityMessage' | t }}
      </p>
    </section>

    <sn-alert dense class="alert-rounded" type="dark">
      <sn-icon fontSet="fal" fontIcon="fa-circle-info"></sn-icon> {{ 'account.dialogs.mfa.backupCodes.securityWarning' | t }}
    </sn-alert>

    <section *ngIf="backupCodes?.tokens?.length">
      <div class="token-container tokenWrapper">
        <div class="token-grid printContent">
          <div class="token-item" *ngFor="let token of backupCodes.tokens">
            {{ token }}
          </div>
        </div>
        <div class="token-actions-wrapper">
          <div class="tokenActions">
            <button mat-button color="accent" (click)="print()">
              <sn-icon fontSet="fal" fontIcon="fa-print"></sn-icon>
              {{ 'common.print' | t }}
            </button>
            <button mat-button [cdkCopyToClipboard]="copyContent" color="accent">
              <sn-icon fontSet="fal" fontIcon="fa-copy"></sn-icon>
              {{ 'common.copy' | t }}
            </button>
          </div>
        </div>
      </div>
    </section>
    <section style="margin-top: 1rem">
      <h3>{{ 'account.dialogs.mfa.backupCodes.securityNote' | t }}</h3>
    </section>
  </div>
</ng-template>
<ng-template #formTmpl>
  <p>{{ 'account.dialogs.mfa.backupCodes.confirmPassword' | t }}</p>
  <sn-form [form]="form" [fields]="formFields" [(model)]="formModel"></sn-form>
</ng-template>
<ng-template #loading>
  <mat-spinner color="accent" diameter="48" mode="indeterminate"></mat-spinner>
</ng-template>

<ng-template #emptyList>
  <sn-empty-state fontSet="fal" fontIcon="fa-shield-xmark" title="{{ 'common.noResults' | t }}">
    {{ 'common.noResultsMatchSearch' | t }}
  </sn-empty-state>
</ng-template>
